<template lang="pug">
  div(:class="`collection collection-${this._uid} ${this.payload.title && this.payload.title.toLowerCase().split(' ').join('-')}`")

    //- Collection item navigation
    nav.collectionNav(v-if="payload.showNavigation")
      ol.collectionNavItems
        li.collectionNavItem(
          v-for="(n, i) in this.payload.itemReferences"
          v-on:click="setActiveItem($event, n.sys.id)"
          :class="activeId === n.sys.id && 'active'") {{ n.fields.name }}

    h3(v-if="this.showTitle && this.payload.title").title.collection-title {{ this.payload.title }}

    div(v-if="!this.payload.linkRefs" class="collection-inner")
      article.item(
        v-if="!payload.showNavigation || activeId === n.sys.id"
        v-for="(n, i) in payload.itemReferences"
        :class="n.fields.classes")
        h3.section-title
          vue-markdown(:source='n.fields.title')
        vue-markdown.desc(:source='n.fields.body || n.fields.desc || n.fields.description')
        image-block(v-if="n.fields.image" :payload="n.fields.image")
        //- Render nested sections
        div(v-if="n.fields.sections")
          section(v-for="(sn, si) in n.fields.sections" :class="`row ${sn.fields.templateId} ${sn.fields.classes && sn.fields.classes.join(' ')}`")
            component(:is="kebabToCamel(sn.fields.templateId)" :payload="sn" :key="sn.sys.id")

    div(v-if="this.payload.linkRefs" class="collection-inner")
      article.item(
        v-if="!payload.showNavigation || activeId === n.sys.id"
        v-for="(n, i) in payload.itemReferences"
        v-on:mouseover="setActiveLink($event, i)"
        :class="`${n.fields.classes} ${i === activeLink ? 'active' : ''}`")
        //- OPTIMIZE: see if there is a more efficient way of doing these switches
        router-link.button.minimal(v-if="!n.fields.url.match('http') && !n.fields.urlLabel && n.fields.url[0] !== '#'" :to="{ name: 'pageScene', params: splitRouteParams(n.fields.url)}" v-on:click.native="register($event)")
          h3.title
            vue-markdown(:source='n.fields.title')
          vue-markdown.desc(:source='n.fields.body || n.fields.desc || n.fields.description')
          image-block(v-if="n.fields.image" :payload="n.fields.image")
        a.wrapper-anchor(v-if="n.fields.url.match('http') && !n.fields.urlLabel || n.fields.url[0] === '#' && !n.fields.urlLabel" :href="n.fields.url" v-on:click.native="register($event)")
          h3.title
            vue-markdown(:source='n.fields.title')
          vue-markdown.desc(:source='n.fields.body || n.fields.desc || n.fields.description')
          image-block(v-if="n.fields.image" :payload="n.fields.image")
        router-link.wrapper-anchor(v-if="n.fields.urlLabel && !n.fields.url.match('http') && n.fields.url[0] !== '#'" v-on:click.native="register($event)" :to="{ name: 'pageScene', params: splitRouteParams(n.fields.url)}")
          h3.title
            vue-markdown(:source='n.fields.title')
          vue-markdown.desc(:source='n.fields.body || n.fields.desc || n.fields.description')
          image-block(v-if="n.fields.image" :payload="n.fields.image")
          router-link.button.minimal(v-if="!n.fields.url.match('http')" :to="{ name: 'pageScene', params: splitRouteParams(n.fields.url)}") {{ n.fields.urlLabel }}
        a.wrapper-anchor(v-if="n.fields.urlLabel && n.fields.url.match('http') || n.fields.url[0] === '#' && n.fields.urlLabel" :href="n.fields.url" v-on:click.native="register($event)")
          h3.title
            vue-markdown(:source='n.fields.title')
          vue-markdown.desc(:source='n.fields.body || n.fields.desc || n.fields.description')
          image-block(v-if="n.fields.image" :payload="n.fields.image")
        a(v-if="n.fields.urlLabel && n.fields.url.match('http') || n.fields.url[0] === '#' && n.fields.urlLabel" class="button minimal" :href="n.fields.url" v-on:click.native="register($event)") {{ n.fields.urlLabel }}

        //- Render nested sections
        div(v-if="n.fields.sections")
          section(v-for="(sn, si) in n.fields.sections" :class="`row ${sn.fields.templateId} ${sn.fields.classes && sn.fields.classes.join(' ')}`")
            component(:is="kebabToCamel(sn.fields.templateId)" :payload="sn" :key="sn.sys.id")

    a(v-if="this.payload.url" class="button" :href="this.payload.url" :name="this.payload.title") {{ this.payload.urlLabel || 'Read more' }}
  //- h1(class="section-title") {{this.title}}
  //- vue-markdown.desc(:source='this.desc')
</template>

<script>
import Vue from 'vue'
import { mapGetters, mapActions } from 'vuex'
import VueMarkdown from 'vue-markdown'
// import pageBase from '@/scenes/_pageBase.js'

import Textblock from '@/components/textblock'

// SECTIONS - only able to implement sections for sub-rendering that don't use Collection component...
import defaultTemplate from '@/components/sections/defaultTemplate'
import articleBlock from '@/components/sections/articleBlock'
import articleHero from '@/components/sections/articleHero'
import Banner from '@/components/sections/banner'
import pageHeader from '@/components/sections/pageHeader'
import pageFooter from '@/components/sections/pageFooter'

// conversation
import conversationBlock from '@/components/sections/conversationBlock'

// component instance
var Collection = Vue.component('collection', {
  name: 'Collection',
  // mixins: [pageBase],
  props: ['payload', 'showNavigation', 'clickableItem', 'showTitle'],
  components: {
    VueMarkdown,
    Textblock,
    defaultTemplate,
    articleBlock,
    articleHero,
    Banner,
    pageHeader,
    pageFooter,
    conversationBlock
  },
  data: function () {
    return {
      activeId: '',
      activeLink: 0
    }
  },
  watch: {
  },
  methods: {
    ...mapActions(['updateStyle']),
    kebabToCamel (s) {
      return s.replace(/(-\w)/g, m => m[1].toUpperCase())
    },
    setActiveLink (e, i) {
      // console.log('setActiveLink', i)
      this.activeLink = i
    },
    setActiveItem (e, id) {
      // console.log(id, e.target);
      // NOTE super hardcoded check for specific entry to change to dark mode
      /* eslint-disable-next-line */
      id === '60z8Mdf0UoSe4kq2aouMQa' ? this.updateStyle(true) : e.target ? this.updateStyle(false) : null
      Vue.set(this, 'activeId', id)

      if (e.target) {
        this.$gtm.trackEvent({
          event: 'interaction', // Event type [default = 'interaction'] (Optional)
          category: 'Collection.item.switch',
          action: 'click',
          label: e.target.textContent,
          value: 1
          // noninteraction: false // Optional
        })
      }
    },
    splitRouteParams (url) {
      let base = url.split('?')[0]
      let paramStrings = url.split('?')[1]
      let params = []

      // console.log(base, paramStrings);

      if (Array.isArray(paramStrings)) {
        const s = paramStrings.split('&')
        s.forEach((n, i) => {
          const p = n.split('=')
          params[p[0]] = [p[1]]
        })
      } else {
        const p = paramStrings.split('=')
        params[p[0]] = [p[1]]
      }
      // trim prepended slash just in case
      base = base[0] === '/' ? base.substr(1) : base

      return { page: base, ...params }
    },
    register (e) {
      if (e.target) {
        this.$gtm.trackEvent({
          event: 'interaction', // Event type [default = 'interaction'] (Optional)
          category: 'Collection.navigate',
          action: 'click',
          label: `${e.target.textContent}`,
          value: 1
          // noninteraction: false // Optional
        })
      }
    }
  },
  computed: {
    ...mapGetters(['isthedarkness'])
  },
  created () {
  },
  mounted () {
    this.$route.params.cid
      ? this.setActiveItem({}, this.$route.params.cid[0])
      : this.setActiveItem({}, this.payload.itemReferences[0].sys.id)
  },
  beforeCreate () {
  },
  beforeUpdate () {
  },
  beforeDestroy () {
  }
})

// export component
export default Collection
</script>

<style lang="scss" scoped>
  .collection-inner{
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;

    align-items: center;
  }

  .two-up .item {
    padding: measure(xxs);
  }
  .three-up .item, .four-up .item {
    padding: measure(xxs);
  }

  .item{
    // padding: measure(xxs);
    // text-align: center;
    .desc {
      // line-height: 1.8 !important; // does not work on nested vue-markdown elements since scoped styles are applied inline at mount
      font-size: font-measure(xs);
    }
  }

  .title{}
  .desc{}
  .collection-title{
    margin: measure(s) 0;
    font-family: $body-font-family;
    text-align: center;
    color: get-color(primary);
    font-weight: 700;
  }

  // collection navigation
  .collectionNav{
    display: flex;

    margin-bottom: measure(sm);

    .collectionNavItems{
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      margin: auto;

      border: 1px solid get-color(secondary);
      padding: .2rem;
      box-sizing: border-box;
    }

    .collectionNavItem{
      cursor: pointer;
      width: measure(m) + 1;
      height: measure(xs);
      text-align: center;
      margin: 0;

      line-height: 1.8;

      background: transparent;
      // border: 1px solid get-color(secondary);

      color: $black;

      transition: background .2s ease-out;

      &.active{
        background: get-color(secondary);
        color: $white;
      }
    }
  }
  .image{
    align-self: flex-start;
    // transform: scale(.5);
    transform-origin: top left;
    // margin-left: measure(sm);
    /* margin-top: -1rem; */
    @include breakpoint(small only) {
      flex: 0 0 100%;
      padding: measure(sm);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/collection.vue